<template>
    <b-container>
      <h1>Create New Conference</h1>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceTitleInputGroup"
                                label="Conference or Event Title:"
                                label-for="conferenceTitleInput">
                    <b-form-input id="conferenceTitleInput"
                                type="text"
                                v-model="form.title"
                                required
                                maxlength=150
                                placeholder="Enter a title">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceLogoInputGroup"
                                label="Logo"
                                label-for="conferenceLogoInput">
                    <b-form-file v-model="file" ref="fileinput" accept="image/*" :state="Boolean(file)" placeholder="Choose a file..." @change="detectFiles($event.target.files)"></b-form-file>
                    <div class="progress-bar" :style="{ width: progressUpload + '%'}">{{ progressUpload }}%</div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-form-group id="conferenceDescriptionInputGroup"
                                label="Description"
                                label-for="conferenceDescriptionInput">
                    <quill-editor id="conferenceDescription"
                            v-model="form.description"
                            placeholder="Please enter some descriptive text about your conference or event."
                            ref="myQuillEditor"
                            :options="editorOptionExpanded">
                    </quill-editor>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceDepartmentInputGroup"
                                label="Choose a Department"
                                label-for="conferenceDepartmentInput">
                    <b-form-select required v-model="form.department" :options="departmentOptions.departmentManagement" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceStartDateInputGroup"
                                label="Start Date:"
                                label-for="conferenceStartDateInput">
                    <b-form-input id="conferenceStartDateInput"
                                type="date"
                                v-model="form.startDate"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceStartTimeInputGroup"
                                label="Start Time:"
                                label-for="conferenceStartTimeInput">
                    <b-form-input id="conferenceStartTimeInput"
                                type="time"
                                v-model="form.startTime"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceEndDateInputGroup"
                                label="End Date:"
                                label-for="conferenceEndDateInput">
                    <b-form-input id="conferenceEndDateInput"
                                type="date"
                                v-model="form.endDate"
                                required
                                :state="dateState"
                                aria-describedby="inputLiveFeedback"
                                >
                    </b-form-input>
                  <b-form-invalid-feedback id="inputLiveFeedback">
                    End Date must be after the Start Date
                  </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceEndTimeInputGroup"
                                label="End Time:"
                                label-for="conferenceEndTimeInput">
                    <b-form-input id="conferenceEndTimeInput"
                                type="time"
                                v-model="form.endTime"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceRegistrationDeadlineDateInputGroup"
                                label="Registration Deadline Date:"
                                label-for="conferenceRegistrationDeadlineDateInput">
                    <b-form-input id="conferenceRegistrationDeadlineDateInput"
                                type="date"
                                v-model="form.registrationDeadlineDate"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceRegistrationDeadlineTimeInputGroup"
                                label="Registration Deadline Time:"
                                label-for="conferenceRegistrationDeadlineTimeInput">
                    <b-form-input id="conferenceRegistrationDeadlineTimeInput"
                                type="time"
                                v-model="form.registrationDeadlineTime"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
          <b-col md="3" class="text-left">
              <b-form-checkbox id="checkboxActive"
                     v-model="form.conferenceActive"
                     >
                     Conference is active
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxPublicConference"
                     v-model="form.publicConference"
                     >
                     Enable simple public conference registration
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3" class="text-left">
              <b-form-checkbox id="checkboxTshirt"
                     v-model="form.askTShirt"
                     >
                     Ask Users T-Shirt Size
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4" class="text-left">
              <b-form-checkbox id="checkboxBreakfast"
                     v-model="form.askBreakfast"
                     >
                     Ask Users Breakfast Selection
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askBreakfast">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceBreakfastQuestionInputGroup"
                                label="Change Default Breakfast Question Text:"
                                label-for="conferenceBreakfastQuestionInput">
              <input type="text" v-model="form.breakfastQuestionText" class="form-control">
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askBreakfast">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceBreakfastOptionsInputGroup"
                                label="Specify Breakfast Options (hit enter after each option):"
                                label-for="conferenceBreakfastOptionsInput">
              <input-tag :tags.sync="form.breakfastOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4" class="text-left">
              <b-form-checkbox id="checkboxLunch"
                     v-model="form.askLunch"
                     >
                     Ask Users Lunch Selection
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askLunch">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceLunchQuestionInputGroup"
                                label="Change Default Lunch Question Text:"
                                label-for="conferenceLunchQuestionInput">
              <input type="text" v-model="form.lunchQuestionText" class="form-control">
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askLunch">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceLunchOptionsInputGroup"
                                label="Specify Lunch Options (hit enter after each option):"
                                label-for="conferenceLunchOptionsInput">
              <input-tag :tags.sync="form.lunchOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4" class="text-left">
              <b-form-checkbox id="checkboxDinner"
                     v-model="form.askDinner"
                     >
                     Ask Users Dinner Selection
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askDinner">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceDinnerQuestionInputGroup"
                                label="Change Default Dinner Question Text:"
                                label-for="conferenceDinnerQuestionInput">
              <input type="text" v-model="form.dinnerQuestionText" class="form-control">
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askDinner">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceDinnerOptionsInputGroup"
                                label="Specify Dinner Options (hit enter after each option):"
                                label-for="conferenceDinnerOptionsInput">
              <input-tag :tags.sync="form.dinnerOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxCME"
                     v-model="form.askCME"
                     >
                     Ask Users if they need CME credit
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxResearchBlitz"
                     v-model="form.askResearchBlitz"
                     >
                     Ask Users if they will participate in the Research Blitz
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxPosterSpecifics"
                     v-model="form.askPosterSpecifics"
                     >
                     Ask Users if they will submit a poster abstract
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askPosterSpecifics">
          <b-col md="12" class="text-left">
            <b-form-group id="conferencePosterCategoryInputGroup"
                                label="Specify Poster Category Options (hit enter after each option):"
                                label-for="conferencePosterCategoryInput">
              <input-tag :tags.sync="form.posterCategoryOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askPosterSpecifics">
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxPosterSubmissionTopic"
                     v-model="form.askPosterSubmissionTopic"
                     >
                     Ask Users for a Submission Topic
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askPosterSubmissionTopic">
          <b-col md="12" class="text-left">
            <b-form-group id="conferencePosterSubmissionTopicInputGroup"
                                label="Specify Poster Submission Topic Options (hit enter after each option):"
                                label-for="conferencePosterSubmissionTopicInput">
              <input-tag :tags.sync="form.posterSubmissionTopicOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="form.askPosterSpecifics">
          <hr>
            <b-row>
              <b-col md="7" class="text-left">
                  <b-form-group id="addtionalPosterInputGroup"
                      label="If you would like to add additional poster related questions please specify the number here:"
                      label-for="additionalPosterInput"
                  >
                  <b-form-input id="additionalPosterInput"
                        type="number"
                        v-model="additionalPosterItems"
                        placeholder="How many more questions"
                        v-on:input="changePosterNum()"
                        >
                  </b-form-input>
                  </b-form-group>
              </b-col>
          </b-row>
          <div v-for="n in extraPosterQuestions.length" :key="n" class="extra-question">
            <div v-if="extraPosterQuestions[n-1]">
              <b-row>
                <h4>{{extraPosterQuestions[n-1].label || "Question Name"}}</h4>
              </b-row>
              <b-row>
                <b-col md="6">
                    <b-form-select required v-model="extraPosterQuestions[n-1].type" :options="options" class="mb-3" />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-input id="additionalPosterInput"
                                type="text"
                                v-on:input="bindPosterModel(n)"
                                v-model="extraPosterQuestions[n-1].label"
                                placeholder="Please add a label for your question"
                                required
                                @keydown="nameKeydown($event)"
                  >
                  </b-form-input>
                </b-col>
                <!-- <b-col md="6" v-if="extraQuestions[n-1].type === 'input'">
                  <b-form-select required v-model="extraQuestions[n-1].inputType" :options="inputTypeOptions" class="mb-3" />
                </b-col> -->
              </b-row>
            </div>
          </div>
        </div>
        <b-row>
          <b-col md="8" class="text-left">
              <b-form-checkbox id="checkboxPosterJudging"
                     v-model="form.askPosterJudging"
                     >
                     Ask users if they are interested in judging posters for this event
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8" class="text-left">
              <b-form-checkbox id="checkboxSpecialNeeds"
                     v-model="form.askSpecialNeeds"
                     >
                     Ask Users if they have any special considerations
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxSocialEvents"
                     v-model="form.askSocialEvents"
                     >
                     Ask Users if they will attend certain events
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askSocialEvents">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceSocialEventsInputGroup"
                                label="Specify Special Event Options (hit enter after each option):"
                                label-for="conferenceSocialEventsInput">
              <input-tag :tags.sync="form.socialEventsOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxEventReferral"
                     v-model="form.askEventReferral"
                     >
                     Ask Users how they heard about this event
              </b-form-checkbox>
          </b-col>
        </b-row>
<hr>
        <b-row>
            <b-col md="7" class="text-left">
                <b-form-group id="addtionalInputGroup"
                    label="If you would like to add additional questions please specify the number here:"
                    label-for="additionalInput"
                >
                <b-form-input id="additionalInput"
                      type="number"
                      v-model="additionalItems"
                      placeholder="How many more questions"
                      v-on:input="changeNum()"
                      >
                </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <div v-for="n in extraQuestions.length" :key="n" class="extra-question">
          <div v-if="extraQuestions[n-1]">
            <b-row>
              <h4>{{extraQuestions[n-1].label || "Question Name"}}</h4>
            </b-row>
            <b-row>
              <b-col md="6">
                  <b-form-select required v-model="extraQuestions[n-1].type" :options="options" class="mb-3" />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-input id="additionalInput"
                              type="text"
                              v-on:input="bindModel(n)"
                              v-model="extraQuestions[n-1].label"
                              placeholder="Please add a label for your question"
                              required
                              @keydown="nameKeydown($event)"
                >
                </b-form-input>
              </b-col>
              <!-- <b-col md="6" v-if="extraQuestions[n-1].type === 'input'">
                <b-form-select required v-model="extraQuestions[n-1].inputType" :options="inputTypeOptions" class="mb-3" />
              </b-col> -->
            </b-row>
          </div>
        </div>
        <b-row>
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxConfirmationPage"
                     v-model="form.confirmationPage"
                     >
                     Redirect users to confirmation page after completing registration
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.confirmationPage">
            <b-col>
              <b-form-group id="conferenceConfirmationInputGroup"
                            label="Conference Confirmation Page"
                            label-for="conferenceConfirmationInput"
                            >
              <quill-editor v-model="form.conferenceConfirmation"
                            ref="myQuillEditor"
                            :options="editorOptionExpanded"
                            >
              </quill-editor>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxPaymentPage"
                     v-model="form.paymentPage"
                     >
                     Redirect users to payment page after completing registration
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.paymentPage">
            <b-col>
              <b-form-group id="conferencePaymentInputGroup"
                                label="Payment Page URL"
                                label-for="conferencePaymentInput">
                    <b-form-input id="conferencePaymentInput"
                                type="text"
                                v-model="form.paymentURL"
                                required
                                maxlength=255
                                placeholder="Enter a url">
                    </b-form-input>
                </b-form-group>
            </b-col>
          </b-row>
        <b-row>
            <b-col>
              <b-form-group id="conferenceWelcomeEmailInputGroup"
                            label="Conference Registration Welcome Email"
                            label-for="conferenceWelcomeEmailInput"
                            >
              <quill-editor v-model="form.conferenceWelcomeEmail"
                            ref="myQuillEditor"
                            :options="editorOption"
                            >
              </quill-editor>
              </b-form-group>
            </b-col>
          </b-row>
        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </b-container>
</template>

<script>
import { db, storage } from '../main'

export default {
  name: 'AddConference',
  computed: {
    dateState () {
      return this.form.endDate === '' ? null : (new Date(this.form.endDate)) >= (new Date(this.form.startDate)) ? true : false
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  firestore () {
    return {
      departmentOptions: db.collection('metadata').doc(this.$store.getters.getUser.uid)
    }
  },
  data () {
    return {
      selected: null,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['clean']
          ]
        }
      },
      editorOptionExpanded: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'align': [] }],
            ['link'],
            ['clean']
          ]
        }
      },
      departmentOptions: [],
      options: [
        {value: {type: null, inputType: null, label: ''}, text: 'Please select a question type'},
        {value: 'input', text: 'Text Field'},
        {value: 'radio', text: 'Yes/No Question'}
      ],
      additionalItems: 0,
      progressUpload: 0,
      file: File,
      uploadTask: '',
      downloadURL: '',
      extraQuestions: [],
      extraPosterQuestions: [],
      form: {
        tShirtsNeeded: {
          Small: 0,
          Medium: 0,
          Large: 0,
          XL: 0,
          XXL: 0,
          None: 0
        },
        breakfastQuestionText: 'Choose a breakfast option:',
        lunchQuestionText: 'Choose a lunch option:',
        dinnerQuestionText: 'Choose a dinner option:',
        extraQuestions: [],
        extraPosterQuestions: [],
        socialEventsOptions: [],
        breakfastOptions: ['Coffee', 'None'],
        lunchOptions: ['Beef', 'Chicken', 'Fish', 'Vegetarian', 'None'],
        dinnerOptions: ['Beef', 'Chicken', 'Fish', 'Vegetarian', 'None'],
        posterCategoryOptions: ['Student', 'Fellow', 'Faculty', 'Staff', 'Other'],
        posterSubmissionTopicOptions: [
          'ALS',
          'Addiction',
          'Aneurysms',
          'Botulinum treatment',
          'Basic neurotransmission',
          'Cellular correlates of sleep disorders',
          'Cellular markers of disease',
          'Child neurology',
          'Cognitive/Behavioral disorders',
          'Epilepsy/Brain metabolism',
          'Headache/Pain',
          'Movement disorders',
          'Neuroimmunology/MS',
          'Neuromuscular disorders',
          'Neuro-oncology',
          'Neuro-ophthalmology',
          'Neurophysiology',
          'Neurorehabilitation',
          'Neurotherapeutics',
          'Neurotrauma (TBI, spinal cord injury, etc.)',
          'Other',
          'Other neurodegenerative disorders',
          'Outcomes/Health services',
          'Stroke/Neurovascular'
        ],
        schema: {
          fields: []
        },
        schemaPoster: {
          fields: []
        },
        title: '',
        logoURL: '',
        description: '',
        startDate: '',
        startTime: '',
        startDateTime: '',
        endDate: '',
        endTime: '',
        endDateTime: '',
        registrationDeadlineDate: '',
        registrationDeadlineTime: '',
        registrationDateTime: '',
        createdAt: ''
      },
      show: true
    }
  },
  methods: {
    nameKeydown (e) {
      console.log(e.key)
      if (e.key === '.') {
        e.preventDefault()
      }
    },
    bindModel (n) {
      this.extraQuestions[n - 1].model = this.extraQuestions[n - 1].label
    },
    bindPosterModel (n) {
      this.extraPosterQuestions[n - 1].model = this.extraPosterQuestions[n - 1].label
    },
    changeNum () {
      if (this.additionalItems < this.extraQuestions.length) {
        var removeItem = this.extraQuestions.slice(0, this.additionalItems)
        this.extraQuestions = removeItem
      } else {
        var i
        for (i = this.extraQuestions.length; i < this.additionalItems; i++) {
          this.extraQuestions.push({
            type: null,
            inputType: null,
            label: ''
          })
        }
      }
      return this.extraQuestions
    },
    changePosterNum () {
      if (this.additionalPosterItems < this.extraPosterQuestions.length) {
        var removeItem = this.extraPosterQuestions.slice(0, this.additionalPosterItems)
        this.extraPosterQuestions = removeItem
      } else {
        var i
        for (i = this.extraPosterQuestions.length; i < this.additionalPosterItems; i++) {
          this.extraPosterQuestions.push({
            type: null,
            inputType: null,
            label: ''
          })
        }
      }
      return this.extraPosterQuestions
    },
    detectFiles (fileList) {
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload (file) {
      if (this.imageName != null) {
        var imageRef = storage.ref().child('images/' + this.imageName)
        imageRef.delete().then(function () {
        }).catch(function (error) {
          throw new Error('Error removing file: ' + error)
        })
      }
      this.uploadTask = storage.ref('images/' + file.name).put(file)
      this.uploadTask.then(snapshot => {
        this.imageName = this.uploadTask.snapshot.metadata.name
        this.downloadURL = this.uploadTask.snapshot.downloadURL
        this.$emit('url', this.downloadURL)
        this.form.logoURL = this.downloadURL
        this.form.logoName = this.uploadTask.snapshot.metadata.name
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.form.createdAt = new Date()
      this.form.startDateTime = new Date(this.form.startDate + ' ' + this.form.startTime)
      this.form.endDateTime = new Date(this.form.endDate + ' ' + this.form.endTime)
      this.form.registrationDateTime = new Date(this.form.registrationDeadlineDate + ' ' + this.form.registrationDeadlineTime)
      // this.form.schema.fields = this.posterSpecifics
      // this.form.schema.fields.sort(function (a, b) { return (a.key > b.key) ? 1 : ((b.key > a.key) ? -1 : 0) })
      this.form.extraQuestions = this.form.schema.fields.concat(this.extraQuestions)
      this.form.extraPosterQuestions = this.form.schemaPoster.fields.concat(this.extraPosterQuestions)
      var conferenceInfo = {}
      this.form.breakfastNeeded = {}
      this.form.lunchesNeeded = {}
      this.form.dinnersNeeded = {}
      this.form.socialEventsCount = {}
      conferenceInfo.conference = this.form
      if (this.dateState) {
        db.collection('Conferences').add(this.form)
          .then(docRef => {
            // delete conferenceInfo.conference.schema
            delete conferenceInfo.conference.adminId
            conferenceInfo.adminId = this.$store.getters.getUser.uid
            conferenceInfo.userId = this.$store.getters.getUser.uid
            conferenceInfo.conference.Id = docRef.id
            alert('Conference successfully added')
            this.$router.replace('/myconferences')
          })
          .catch(function (error) {
            console.error('Error adding document: ', error)
          })
        // this.extraQuestions = {
        //   schema: {
        //     fields: [
        //     ]
        //   }
        // }
        this.form = {
          title: '',
          logoURL: '',
          description: '',
          startDate: '',
          startTime: '',
          endDate: '',
          endTime: '',
          registrationDeadlineDate: '',
          registrationDeadlineTime: ''
        }
        this.progressUpload = 0
        this.$refs.fileinput.reset()
      }
    },
    onReset (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form = []
      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => { this.show = true })
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      })
    }
  }
}
</script>

<style scoped>
.container {
  margin-top: 15px;
}
.b-form-group {
  text-align: left;
}
.btn {
  border-radius: 0px;
}
.extra-question {
  margin-bottom: 15px;
}
.form-control.vue-input-tag-wrapper {
  min-height: 38px;
  overflow-y: auto;
}
#conferencePosterSubmissionTopicInputGroup .form-control.vue-input-tag-wrapper {
  min-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/AddConference.vue